import { createContext, useCallback, useContext, useMemo, useState } from 'react';

const ModalContext = createContext(null);

export function ModalProvider({ children }) {
  const [modal, setModal] = useState(null);

  const show = useCallback((opts) => {
    return new Promise((resolve) => {
      setModal({
        ...opts,
        onClose: (result) => {
          setModal(null);
          resolve(result);
        }
      });
    });
  }, []);
  const hide = useCallback(() => setModal(null), []);
  const value = useMemo(() => ({ show, hide }), [show, hide]);

  return (
    <ModalContext.Provider value={value}>
      {children}
      {modal ? <ModalBackdrop modal={modal} /> : null}
    </ModalContext.Provider>
  );
}

function ModalBackdrop({ modal }) {
  const buttons = modal.buttons || [{ label: 'OK', variant: 'primary' }];
  return (
    <div className="modal-backdrop" onClick={() => modal.dismissable !== false && modal.onClose(null)}>
      <div className="modal-panel" onClick={(e) => e.stopPropagation()}>
        {modal.title ? <h3 className="h3" style={{ marginBottom: 8 }}>{modal.title}</h3> : null}
        {modal.message ? <p className="dim" style={{ margin: '0 0 16px' }}>{modal.message}</p> : null}
        {modal.body || null}
        <div className="row" style={{ justifyContent: 'flex-end', marginTop: 16 }}>
          {buttons.map((b, i) => (
            <button
              key={i}
              className={`btn btn-${b.variant || 'ghost'}`}
              onClick={() => {
                modal.onClose(b.value ?? b.label);
                if (typeof b.onPress === 'function') b.onPress();
              }}
            >
              {b.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export function useModal() {
  const ctx = useContext(ModalContext);
  if (!ctx) throw new Error('useModal must be inside ModalProvider');
  return ctx;
}
